module.exports = __webpack_public_path__ + "static/media/ddk-mainslide-02.8927dc12.jpg";